<template>
	<div class="sub-values">
		<div class="sub-value">
			<div class="label">{{ data.min }} - {{ data.max }} Stunden pro Woche</div>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		data: {
			type: Object,
			required: true,
		},
	}
}
</script>
